import axios from 'axios';
const config = require('../../configuration')
const API_BASE_URL = config.API_BASE_URL;

export async function getChart({ params, method = 'GET', urlApi = '' }) {
    try {
        const url = `${API_BASE_URL}/${urlApi}`;
        const response = await axios({ url, method, params });
        return response.data
    } catch (error) {
        return []
    }
}